import { Select } from "@ddm-design-system/select";
import { ChipInput } from "@ddm-design-system/chip";
import { ComponentRegistry } from "@ddm-design-system/base";

ComponentRegistry.register(ChipInput, "ChipInput");

export default Select;
